/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_XY_LIVE", "566")
  

// 接口文档

  
    
export interface IAPI77050ResListItemAppInstanceObjComponentInstanceListItemBlockListItemPropertyListItemOptionListItem {
  
  /** 选项名称 */
  key?: string;
  
  /** 选项值 */
  value?: string;
  
};
    
  
    
export interface IAPI77050ResListItemAppInstanceObjComponentInstanceListItemBlockListItemPropertyListItem {
  
  /** 属性编码 */
  propertyCode?: string;
  
  /** 属性名称 */
  propertyName?: string;
  
  /** 属性类型 */
  propertyType?: string;
  
  /** 属性key */
  propertyKey?: string;
  
  /** 属性值 */
  propertyValue?: string;
  
  /** 选中值 */
  selectValue?: string;
  
  /** 选项范围 ,OptionResp */
  optionList?: IAPI77050ResListItemAppInstanceObjComponentInstanceListItemBlockListItemPropertyListItemOptionListItem[];
  
};
    
  
    
export interface IAPI77050ResListItemAppInstanceObjComponentInstanceListItemBlockListItem {
  
  /** 区块名称 */
  blockName?: string;
  
  /** 区块类型 */
  blockType?: string;
  
  /** 最少数量 */
  leastNum?: number;
  
  /** 最多数量 */
  mostNum?: number;
  
  /** 属性列表 ,AppPropertyResp */
  propertyList?: IAPI77050ResListItemAppInstanceObjComponentInstanceListItemBlockListItemPropertyListItem[];
  
};
    
  
    
export interface IAPI77050ResListItemAppInstanceObjComponentInstanceListItem {
  
  /** 组件模板编码 */
  componentCode?: string;
  
  /** 坐标 */
  coordinate?: string;
  
  /** 组件模板名称 */
  componentName?: string;
  
  /** 组件分类 */
  componentClassify?: string;
  
  /** 组件类型 */
  componentType?: string;
  
  /** 区块列表 ,AppBlockResp */
  blockList?: IAPI77050ResListItemAppInstanceObjComponentInstanceListItemBlockListItem[];
  
};
    
  
    
export interface IAPI77050ResListItemAppInstanceObjPropertyLineListItem {
  
  /** 输出属性编码 */
  outPropertyCode?: string;
  
  /** 输入属性编码 */
  inPropertyCode?: string;
  
};
    
  
    
export interface IAPI77050ResListItemAppInstanceObj {
  
  /** 应用实例编码 */
  appInstanceCode?: string;
  
  /** 应用版本 */
  appVersion?: string;
  
  /** 实例状态 */
  appStatus?: number;
  
  /** 组件实例列表 ,AppComponentResp */
  componentInstanceList?: IAPI77050ResListItemAppInstanceObjComponentInstanceListItem[];
  
  /** 属性连线列表 ,AppPropertyLineResp */
  propertyLineList?: IAPI77050ResListItemAppInstanceObjPropertyLineListItem[];
  
};
    
  
    
export interface IAPI77050ResListItem {
  
  /** 应用编码 */
  appCode?: string;
  
  /** 应用名称 */
  appName?: string;
  
  /** 应用描述 */
  appDesc?: string;
  
  /** 是否多轮 */
  multiFlag?: number;
  
  /** 是否发布 */
  releaseFlag?: number;
  
  /** 创建时间 */
  createdAt?: string;
  
  /** AppInstanceResp */
  appInstance?: IAPI77050ResListItemAppInstanceObj;
  
};
    
  



export interface API77050Req {
  
  /** 应用名称 */
  appName?: string;
    
  /**  */
  pageSize?: string;
    
  /**  */
  pageIndex?: string;
    
  /**  */
  rowId?: string;
    
  /**  */
  jumpType?: string;
    
  /**  */
  searchCount?: string;
    
  /**  */
  orderObjects?: string;
    
};



export interface API77050Res {
  /** T  */
  list?: IAPI77050ResListItem[];
  /**   */
  totalNumber?: number;
  /**   */
  totalPage?: number;
  /**   */
  rowId?: string;
  /**   */
  hasNext?: boolean;
  /**   */
  pageSize?: number;
  /**   */
  pageIndex?: number;
  
};


// 接口函数 77050 查询应用实例列表

export interface IUseGetAPI77050Return {
  /** 查询应用实例列表: 接口请求状态 */
  isAPI77050Loading: boolean;
  /** 查询应用实例列表: 接口请求返回数据 */
  dataAPI77050: API77050Res;
  /**  查询应用实例列表: 接口数据请求方法 */
  fetchAPI77050Data: (inputs: API77050Req, config?: YWRequestConfig) => Promise<API77050Res>;
  /** 查询应用实例列表: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI77050 = ():IUseGetAPI77050Return => {
  let isMount = true;
  const [isAPI77050Loading, setIsAPI77050Loading] = useState(false);
  const [dataAPI77050, setDataAPI77050] = useState<API77050Res>({} as API77050Res);
  const requestUrl = `${basePath}/yoaichat-admin/app/page`;

  const fetchAPI77050Data = async (inputs: API77050Req, config?: YWRequestConfig): Promise<API77050Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API77050Req>) || {}) as API77050Req;
    
  
    if ( isMount ) {
      setIsAPI77050Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API77050Res>(`${basePath}/yoaichat-admin/app/page?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI77050(res || {} as API77050Res);
        setIsAPI77050Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI77050Loading(false);
      }
      return false as unknown as API77050Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI77050Loading,
    dataAPI77050,
    fetchAPI77050Data,
    requestUrl,
  }
}

